import { render } from "./Home.vue?vue&type=template&id=680a4bf1&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=680a4bf1&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680a4bf1"]])

export default __exports__